import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, mergeProps as _mergeProps, vShow as _vShow, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "contentHeader flex" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = { class: "block w-full" }
const _hoisted_4 = { class: "flex mb-4" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "icon-neu" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["disabled", "title"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon-loeschen" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["disabled", "title"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "icon-downlaod" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "icon-suche" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "ml-auto" }
const _hoisted_18 = { class: "text-center" }

import { onBeforeUnmount, onMounted, reactive, ref } from "vue";
    import { BryntumGrid } from "@bryntum/grid-vue-3";
    import { Menu, Store, StringHelper } from "@bryntum/grid";
    import GridInputFilter from "@/components/GridInputFilter";
    import { useGlobalStore } from "@/stores/GlobalStore";
    import { ErrorLocationType, PopupType, TableType } from '@/utilities/enums/Enums';
    import { $t } from "@/utilities/i18n/config";
    import { PermissionService } from "@/utilities/services/PermissionService";
    import dialog from "@/dialog";
    import ErrorHandler from "@/utilities/helpers/ErrorHandler";
    import Error from "@/components/Error";
    import { useI18n } from "vue-i18n";
    import { checkboxColumnConfig, defaultSpaceAroundTableOnPage } from "@/AppConfig";
    import router from "@/router";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import { CompanyInfo } from "@/models/company/CompanyInfo";
    import { useProviderStore } from "@/stores/ProviderStore";
    import { CompanyService } from "@/utilities/services/entities/CompanyService";
    import exportFromJSON from "export-from-json";
    import { ExtendedProviderCsvExport } from "@/models/CsvExportModels";
    import { CompanyWorkerService } from "@/utilities/services/entities/CompanyWorkerService";
    import { CompanyWorkerInfo } from "@/models/company/CompanyWorkerInfo";
    import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Provider',
  setup(__props) {

    const gridStore = new Store();
    const globalStore = useGlobalStore();
    const providerStore = useProviderStore();
    //const selectedCompany = ref(undefined);

    let selectedProviders = ref<CompanyInfo[]>([]);

    const { t } = useI18n();
    const companyService = new CompanyService();
    const permissionService = new PermissionService();
    const companyWorkerService = new CompanyWorkerService();

    const currentWindowHeight = ref("");
    const recalcGridHeight = () => {
        currentWindowHeight.value = `${window.innerHeight - defaultSpaceAroundTableOnPage}px`;
    };

    const deleteSelection = async () => {
        //drop call without selection
        if (!selectedProviders.value?.some(() => true)) return;

        const answer = await dialog
            .okText(t("global.delete"))
            .cancelText(t("global.cancel"))
            .confirm(t("providerManagement.confirmDeletionMulti", { count: selectedProviders.value.length }));

        if (answer) {
            let someEntriesFailed = false;
            for (const p of selectedProviders.value) {
                const resp = await companyService.deleteSystemConnectionToCompany(p.id);

                if (resp === null || resp === undefined || resp?.statusCode !== 0) {
                    ErrorHandler.handleError(resp, ErrorLocationType.table);
                    someEntriesFailed = true;
                    continue;
                }

                gridStore.applyChangeset({ removed: [{ id: p.id }] });
            }

            if (someEntriesFailed) return;

            globalStore.showSuccess(t("global.deleted"));
        }
    };
    const openSearchCompanyWorker = async () => {

        globalStore.openPopup({
            data: new CompanyWorkerInfo(),
            action: checkForExistingPhoneNumber,
            resetButton: false,
            title: $t("popups.providerManagementDetails.new"),
            type: PopupType.providerCompanyWorkerFinderPopup
        });
    }

    const checkForExistingPhoneNumber = async () => {
        globalStore.modal.contentObject.userInfo = "";
        const companyWorker = globalStore.modal.contentObject as CompanyWorkerInfo;
        companyWorker.showUserInfo = false;
        const foundCompanyWorkerResp = await companyWorkerService.postSearchCompanyWorkerJustByPhonenumber(companyWorker.dialCode, companyWorker.phoneNumber);
        if (foundCompanyWorkerResp === null || foundCompanyWorkerResp === undefined || foundCompanyWorkerResp.statusCode !== 0) {
            ErrorHandler.handleError(foundCompanyWorkerResp, ErrorLocationType.popup);
            return;
        }
        if (foundCompanyWorkerResp.statusMessage !== "") {
            if (!NullOrUndefinedHelper(foundCompanyWorkerResp.user)) {
                foundCompanyWorkerResp.user.id = foundCompanyWorkerResp.user?.userId;
                companyWorker.companyName = foundCompanyWorkerResp.companyName;
                companyWorker.email = foundCompanyWorkerResp.user?.email;
                companyWorker.fullName = foundCompanyWorkerResp.user?.firstName + " " + foundCompanyWorkerResp.user?.lastName;
                companyWorker.companyId = foundCompanyWorkerResp.user?.companyId;
                companyWorker.showUserInfo = true;
            }

            return;
        }
    }
    /*** This function allows you to export information on the selected companies
    and a list of their employees in CSV format.
    ***/
    const exportCSV = async () => {
        globalStore.gridDataIsLoading = true;

        const companyIds = selectedProviders.value?.map((item: any) => item.id) || [];

        try {
            const response = await companyWorkerService.getExtendedCompanyEmployeesExport(companyIds);

            const companies = response.companyAnabUserInfos || [];
            if (!Array.isArray(companies)) {
                throw new Error("Unexpected response structure.");
            }

            const csvData: ExtendedProviderCsvExport[] = [];

            companies.forEach((company: any) => {
                if (Array.isArray(company.systems) && company.systems.length > 0) {
                    company.systems.forEach((system: any) => {
                        const systemName = system?.name || "";

                        if (Array.isArray(system.users) && system.users.length > 0) {
                            system.users.forEach((user: any) => {
                                const combinedData = {
                                    companyName: company.companyName,
                                    companyId: (system.idCode || "") + (system.companyIdCode || ""),
                                    firstName: user.vorname || "",
                                    lastName: user.nachname || "",
                                    email: user.normalizedUserName || "", // peut être email ou numéro
                                    phoneNumber: user.countryPhoneNumber || (user.dialCode || "") + (user.phoneNumber || ""),
                                    admin: user.isAdmin || false,
                                    anAbSystemName: systemName,
                                };
                                csvData.push(new ExtendedProviderCsvExport(combinedData));
                            });
                        } else {
                            const combinedData = {
                                companyName: company.companyName,
                                companyId: (system.idCode || "") + (system.companyIdCode || ""),
                                firstName: "",
                                lastName: "",
                                email: "",
                                phoneNumber: "",
                                admin: false,
                                anAbSystemName: systemName,
                            };
                            csvData.push(new ExtendedProviderCsvExport(combinedData));
                        }
                    });
                }
            });

            exportFromJSON({
                data: csvData,
                fileName: "Dienstleisterexport",
                exportType: exportFromJSON.types.csv,
            });

        } catch (error) {
            console.error("Error occurs during extended CSV export", error);
        } finally {
            globalStore.gridDataIsLoading = false;
        }
    };
    const grid = ref(null);

    const useGridConfig = {
        headerMenuFeature: false,
        cellTooltipFeature: {
            hoverDelay: 300,
            textContent: true,
            hideOnDelegateChange: true,
        },
        relayStoreEvents: true,
        enableTextSelection: true,
        selectionMode: {
            row: true,
            checkbox: checkboxColumnConfig,
            showCheckAll: true,
            deselectFilteredOutRecords: true
        },
        columns: {
            data: [

                {
                    id: 'name',
                    field: 'name',
                    text: t('providerManagement.grid.companyName'),
                    flex: 1,
                },
                {
                    id: 'info',
                    field: 'info',
                    text: "",
                    width: 60,
                    sortable: false,
                    resizable: false,
                    minWidth: 60,
                    type: "template",
                    tooltipRenderer: ({ record }) => {
                        if (record.data.info == null || record.data.info == '') {
                            return StringHelper.xss``
                        } else {
                            return StringHelper.xss`${record.data.info}`
                        }
                    },
                    template: ({ record }) => {
                        if (record.data.info == '' || record.data.info == null) {
                            return "";
                        } else {
                            return `<div class="gridTooltipButton"><span class="icon-info text-blue"></span></div>`;
                        }
                    },
                },
                {
                    id: 'address',
                    field: 'address',
                    text: t('providerManagement.grid.adress'),
                    flex: 2,
                },
                {
                    id: 'companyIdCode',
                    field: 'companyIdCode',
                    text: t('providerManagement.grid.companyIdCode'),
                    flex: 1,
                    type: 'template',
                    template: ({ record }: any) => {
                        return globalStore.settings.systemCompanySettings?.companyIdCode
                            ? `<span class="transparentGrey">${globalStore.settings.systemCompanySettings?.companyIdCode}</span>${record.data.companyIdCode}`
                            : `${record.data.companyIdCode}`;
                    },
                },
                {
                    id: 'statistic.pendingWorkerAssignments',
                    field: 'statistic.pendingWorkerAssignments',
                    text: '',
                    width: 36,
                    type: "template",
                    tooltipRenderer: ({ record }) => {
                        if (record.data.statistic?.pendingWorkerAssignments > 0) {
                            return StringHelper.xss`${t('providerManagement.inactiveUsers')}`;
                        }
                    },
                    template: ({ record }) => {
                        const classStr = record.data.statistic?.pendingWorkerAssignments > 0 ? 'icon-status_bald_inaktiv bg-red text-white' : 'icon-person';
                        const buttonClassStr = record.data.statistic?.pendingWorkerAssignments > 0 ? 'gridRowWarningButton' : 'gridRowButton';

                        return `<div class='${buttonClassStr}'><span class='${classStr}'></span></div>`;
                    },
                },
                {
                    id: 'menu',
                    text: '',
                    width: 36,
                    type: 'widget',
                    align: "center",
                    hideable: false,
                    resizable: false,
                    sortable: false,
                    filterable: false,
                    widgets: [{
                        type: 'button',
                        width: 36,
                        icon: 'icon-kontext_horizontal',
                        onAction: ({ source: btn }) => {
                            const menu = menuFactory(btn.cellInfo.record.data);
                            menu.alignTo({ target: btn })
                            menu.show();
                        }
                    }]
                },
            ],
            listeners: {
                async add(event: any) {
                    if (event.records.length === 1 && event.isMove[event.records[0].id]) {
                        await globalStore.saveUserColumnOrder(TableType[TableType.provider], event.records[0].id, event.index.toString());
                    }
                },
            }
        },
        store: gridStore,
        listeners: {
            selectionChange(event) {
                if (event.selection.length > 0 && event.selection[0]?.data === undefined) return;
                selectedProviders.value = selectedProviders.value.concat(event.selected.map(pr => pr.data))
                selectedProviders.value = selectedProviders.value.filter(p => !event.deselected.map(pr => pr.data).some(pr => p?.id === pr?.id));
            },
            datachange() {
                globalStore.currentItems = gridStore.count;
                globalStore.allItems = gridStore.originalCount;
            },
            cellClick({ column, record }) {
                if (column.data.field === 'statistic.pendingWorkerAssignments') {
                    if (permissionService.userHasPermission("ProviderManagementPolicy.CompanyWorker.Read")) {
                        router.push(`/providermanagement/${record.data.companyId ?? record.data.id}`)
                    }
                }
            },
        },
        height: currentWindowHeight,
    }
    const gridConfig = reactive(useGridConfig);

    const menuFactory = (record: object) => {
        const menu = new Menu({
            anchor: true,
            autoShow: true,
            items: [
                {
                    text: t("providerManagement.grid.showStaff"),
                    cls: 'color',
                    icon: 'icon-status_aktiv',
                    hidden: !permissionService.userHasPermission("ProviderManagementPolicy.CompanyWorker.Read"),
                    weight: 100,
                    onItem: ({ menu }) => {
                        router.push({ path: `/providermanagement/${menu.record.companyId ?? menu.record.id}` })
                    }
                },
                {
                    text: t("global.edit"),
                    cls: 'color',
                    icon: 'icon-editieren',
                    hidden: !permissionService.userHasPermission("ProviderManagementPolicy.Edit"),
                    weight: 100,
                    onItem: ({ menu }) => {
                        globalStore.openPopup({
                            data: menu.record,
                            action: providerStore.addOrUpdateProvider,
                            resetButton: false,
                            title: $t("popups.providerManagement.edit"),
                            type: PopupType.providerManagementEditPopup
                        });
                    }
                },
                {
                    text: t("global.delete"),
                    hidden: !permissionService.userHasPermission("ProviderManagementPolicy.Delete"),
                    cls: 'color',
                    icon: 'icon-loeschen',
                    weight: 140,
                    onItem: async ({ menu }) => {
                        const answer = await dialog
                            .okText(t("global.delete"))
                            .cancelText(t("global.cancel"))
                            .confirm(t("providerManagement.confirmDeletionSingle", { name: menu.record.name }));

                        if (answer) {
                            const resp = await companyService.deleteSystemConnectionToCompany(menu.record.id);

                            if (resp === null || resp === undefined || resp?.statusCode !== 0) {
                                ErrorHandler.handleError(resp, ErrorLocationType.table);
                                return;
                            }

                            gridStore.applyChangeset({ removed: [{ id: menu.record.id }] });

                            globalStore.showSuccess(t('global.deleted'));
                        }
                    }
                }
            ],
        });

        menu.setRecord(record);

        return menu;
    };

    const newProvider = () => {
        globalStore.openPopup({
            data: new CompanyInfo(),
            action: providerStore.addOrUpdateProvider,
            resetButton: false,
            title: $t("popups.providerManagement.new"),
            type: PopupType.providerManagementEditPopup
        });
    }

    const setGridData = async () => {
        // start spinner
        globalStore.gridDataIsLoading = true;

        const companyResp = await companyService.getCompanyDetails();
        if (companyResp === null || companyResp === undefined || companyResp.statusCode !== 0) {
            ErrorHandler.handleError(companyResp, ErrorLocationType.table);
            return;
        }

        gridStore.setStoreData(companyResp.anAbCompaniesInfo);

        globalStore.reorderColumns(TableType[TableType.provider]);

        // stop spinner
        globalStore.gridDataIsLoading = false;
    };

    onMounted(async () => {
        // calculate grid height and sub to window resize event

        recalcGridHeight();
        window.addEventListener('resize', recalcGridHeight);

        globalStore.setGridStore(ref(gridStore));
        globalStore.setGridColumnStore(ref(grid.value?.instance.value?.columns));

        await setGridData();
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', recalcGridHeight);

        globalStore.setGridStore(null);
        globalStore.setGridColumnStore(null);

        globalStore.currentItems = 0;
        globalStore.allItems = 0;
    });

return (_ctx: any,_cache: any) => {
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", null, _toDisplayString(_unref($t)("providerManagement.title")), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_unref(Error), {
          errorLoc: _unref(ErrorLocationType).table
        }, null, 8, ["errorLoc"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: newProvider,
              title: _unref(t)('providerManagement.new')
            }, _hoisted_7, 8, _hoisted_5)), [
              [_directive_permission, 'ProviderManagementPolicy.Create']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              disabled: !_unref(selectedProviders).some(()=>true),
              onClick: deleteSelection,
              title: _unref(t)('global.delete')
            }, _hoisted_10, 8, _hoisted_8)), [
              [_directive_permission, 'ProviderManagementPolicy.Delete']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              disabled: !_unref(selectedProviders).some(()=>true),
              class: "primary mr-2",
              onClick: exportCSV,
              title: _unref(t)('global.exportCsv')
            }, _hoisted_13, 8, _hoisted_11)), [
              [_directive_permission, 'ProviderManagementPolicy.CSV.Import']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "primary mr-2",
              onClick: openSearchCompanyWorker,
              title: _unref(t)('global.search')
            }, _hoisted_16, 8, _hoisted_14)), [
              [_directive_permission, 'ProviderManagementPolicy.Read']
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(GridInputFilter), {
                gridStore: _unref(gridStore),
                hideFilterButton: true
              }, null, 8, ["gridStore"])
            ])
          ]),
          _createVNode(_unref(BryntumGrid), _mergeProps({
            ref_key: "grid",
            ref: grid
          }, gridConfig, { readOnly: true }), null, 16)
        ])
      ], 512), [
        [_vShow, !_unref(globalStore).gridDataIsLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_18, [
        _createVNode(LoadingSpinner)
      ], 512), [
        [_vShow, _unref(globalStore).gridDataIsLoading]
      ])
    ])
  ], 64))
}
}

})